/**
 * @generated SignedSource<<dd12ceff66007c9d03a4377516d75de0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardContentOld_project$data = {
  readonly projectId: string;
  readonly " $fragmentSpreads": FragmentRefs<"BoardContentOld_Inner_project">;
  readonly " $fragmentType": "BoardContentOld_project";
};
export type BoardContentOld_project$key = {
  readonly " $data"?: BoardContentOld_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardContentOld_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardContentOld_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardContentOld_Inner_project"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW",
      "path": "projectId"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "439a1d1fb9bd8ef9237391a29cebccb0";

export default node;
